// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SectionHeader Styles
 * 
 * This CSS module contains styles for the SectionHeader component in the Lobby2.0 application.
 * It defines the layout and appearance of the section header, including responsive designs.
 *
 * Key Components:
 * - .sectionHeader: Main container for the section header
 * - .sectionTitle: Styles for the section title
 * - .headerLeft / .headerRight: Flex containers for left and right content in the header
 * - .sectionIcon / .iconImage: Styles for section icons
 * - .allGamesLink: Styles for the "All Games" link
 * - .arrowIcon: Styles for the arrow icon in the "All Games" link
 *
 * Responsive Breakpoints:
 * - 1024px: Adjustments for tablet-sized screens
 * - 375px: Adjustments for mobile-sized screens
 *
 * CSS Variables Used:
 * - --header-title-height-multiview: Defines the line height of the header title in multiview
 * - --header-title-height-singleview: Defines the line height of the header title in singleview
 * - --header-background-color: Background color for the header in single view mode
 * - --ghost-white-color: Color for selected navigation items
 * - --header-title-font-size: Font size for the header title
 */
.UCqH7PY3GBBxa93VfsWv {
  padding: 0 8px;
  height: var(--header-title-height-multiview);
  background: transparent;
  font-weight: 700;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  font-size: 20px;
}
.UCqH7PY3GBBxa93VfsWv[data-view='single'] {
  backdrop-filter: blur(4px);
  height: var(--header-title-height-singleview);
  min-height: var(--header-title-height-singleview);
  /* fix bug in ingame mode */
  padding: 0 8px;
}
@media (min-width: 825px) {
  .UCqH7PY3GBBxa93VfsWv[data-view='single'] {
    padding: 0 16px;
  }
}
.UCqH7PY3GBBxa93VfsWv[data-view='single'] .Onx2lHOrDVwVUGNAMXXj {
  color: var(--ghost-white-color);
}
.AFQshpVRLzmOqw4T8IKy,
.gBPUXFzCHwlcBRqlHOTg {
  display: flex;
  align-items: center;
  gap: 8px;
}
.GmMESR1jWabG1jr0PVBA {
  position: relative;
  display: inline-flex;
  align-items: center;
}
.s8s0GBOw2zfSs7zqRLdZ {
  min-width: 32px;
  height: 30px;
  vertical-align: middle;
  filter: brightness(0) saturate(100%) invert(100%);
}
/* Seasonal icons (christmas): the icon itself takes candle amber (#ffb84d). Flat colour only:
   a glow made the icons look blurry. Christmas has no palette (the lobby colours stay), so the
   recipe is pinned here and reaches section headers only, never the nav bar or status bar —
   those keep the stock green --filter-active-icon. Halloween keeps the stock icons. */
html[data-seasonal-branding='christmas'] .zqctkfpFqyBcMjJaKEEw .s8s0GBOw2zfSs7zqRLdZ {
  filter: brightness(0) saturate(100%) invert(83%) sepia(71%) saturate(1401%) hue-rotate(310deg) brightness(90%) contrast(132%);
}
.y4N_jZuuajlGHIxrBTDY {
  border-radius: 34px;
  color: var(--white-color);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: var(--header-all-game-font-size);
  font-weight: 700;
  height: 20px;
  line-height: initial;
  padding: 0 5px;
  text-wrap-mode: nowrap;
}
.oJzYTMDTw3iY9ozMXidd {
  width: 7px;
  height: 12px;
  transition: transform 0.2s ease;
}
.Onx2lHOrDVwVUGNAMXXj {
  text-transform: uppercase;
  font-size: var(--header-title-font-size);
  font-weight: 700;
}
/* Responsive breakpoints */
/*@media (max-width: 824px) {*/
/*  [data-open-type="ingame"] {*/
/*    .backIcon {*/
/*      height: 25px;*/
/*    }*/
/*  }*/
/*}*/
@media (max-width: 1025px) {
  /* fallow-ignore-next-line unused-export */
  .tAQdjpV2tt404lGk0uWj[data-view='single'] .UCqH7PY3GBBxa93VfsWv {
    margin-bottom: 14px;
  }
}
@media (min-width: 1025px) {
  .UCqH7PY3GBBxa93VfsWv {
    padding: 0 20px;
  }
  .y4N_jZuuajlGHIxrBTDY {
    border-width: 2px;
    height: 30px;
    padding: 0 8px;
  }
  .oJzYTMDTw3iY9ozMXidd {
    width: 10.5px;
    height: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/Section/SectionHeader/SectionHeader.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE;AACF;EACE,cAAc;EACd,4CAA4C;EAC5C,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,6CAA6C;EAC7C,iDAAiD;EACjD,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,+BAA+B;AACjC;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,iDAAiD;AACnD;AACA;;;sFAGsF;AACtF;EACE,6HAA6H;AAC/H;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2CAA2C;EAC3C,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,gBAAgB;AAClB;AACA,2BAA2B;AAC3B,8BAA8B;AAC9B,gCAAgC;AAChC,kBAAkB;AAClB,sBAAsB;AACtB,QAAQ;AACR,MAAM;AACN,IAAI;AACJ;EACE,0CAA0C;EAC1C;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,YAAY;IACZ,cAAc;EAChB;EACA;IACE,aAAa;IACb,YAAY;EACd;AACF","sourcesContent":["/**\n * SectionHeader Styles\n * \n * This CSS module contains styles for the SectionHeader component in the Lobby2.0 application.\n * It defines the layout and appearance of the section header, including responsive designs.\n *\n * Key Components:\n * - .sectionHeader: Main container for the section header\n * - .sectionTitle: Styles for the section title\n * - .headerLeft / .headerRight: Flex containers for left and right content in the header\n * - .sectionIcon / .iconImage: Styles for section icons\n * - .allGamesLink: Styles for the \"All Games\" link\n * - .arrowIcon: Styles for the arrow icon in the \"All Games\" link\n *\n * Responsive Breakpoints:\n * - 1024px: Adjustments for tablet-sized screens\n * - 375px: Adjustments for mobile-sized screens\n *\n * CSS Variables Used:\n * - --header-title-height-multiview: Defines the line height of the header title in multiview\n * - --header-title-height-singleview: Defines the line height of the header title in singleview\n * - --header-background-color: Background color for the header in single view mode\n * - --ghost-white-color: Color for selected navigation items\n * - --header-title-font-size: Font size for the header title\n */\n.sectionHeader {\n  padding: 0 8px;\n  height: var(--header-title-height-multiview);\n  background: transparent;\n  font-weight: 700;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  font-size: 20px;\n}\n.sectionHeader[data-view='single'] {\n  backdrop-filter: blur(4px);\n  height: var(--header-title-height-singleview);\n  min-height: var(--header-title-height-singleview);\n  /* fix bug in ingame mode */\n  padding: 0 8px;\n}\n@media (min-width: 825px) {\n  .sectionHeader[data-view='single'] {\n    padding: 0 16px;\n  }\n}\n.sectionHeader[data-view='single'] .sectionName {\n  color: var(--ghost-white-color);\n}\n.headerLeft,\n.headerRight {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.iconWrapper {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n.iconImage {\n  min-width: 32px;\n  height: 30px;\n  vertical-align: middle;\n  filter: brightness(0) saturate(100%) invert(100%);\n}\n/* Seasonal icons (christmas): the icon itself takes candle amber (#ffb84d). Flat colour only:\n   a glow made the icons look blurry. Christmas has no palette (the lobby colours stay), so the\n   recipe is pinned here and reaches section headers only, never the nav bar or status bar —\n   those keep the stock green --filter-active-icon. Halloween keeps the stock icons. */\nhtml[data-seasonal-branding='christmas'] .iconSeasonal .iconImage {\n  filter: brightness(0) saturate(100%) invert(83%) sepia(71%) saturate(1401%) hue-rotate(310deg) brightness(90%) contrast(132%);\n}\n.allGamesLink {\n  border-radius: 34px;\n  color: var(--white-color);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: var(--header-all-game-font-size);\n  font-weight: 700;\n  height: 20px;\n  line-height: initial;\n  padding: 0 5px;\n  text-wrap-mode: nowrap;\n}\n.arrowIcon {\n  width: 7px;\n  height: 12px;\n  transition: transform 0.2s ease;\n}\n.sectionName {\n  text-transform: uppercase;\n  font-size: var(--header-title-font-size);\n  font-weight: 700;\n}\n/* Responsive breakpoints */\n/*@media (max-width: 824px) {*/\n/*  [data-open-type=\"ingame\"] {*/\n/*    .backIcon {*/\n/*      height: 25px;*/\n/*    }*/\n/*  }*/\n/*}*/\n@media (max-width: 1025px) {\n  /* fallow-ignore-next-line unused-export */\n  .sectionContainer[data-view='single'] .sectionHeader {\n    margin-bottom: 14px;\n  }\n}\n@media (min-width: 1025px) {\n  .sectionHeader {\n    padding: 0 20px;\n  }\n  .allGamesLink {\n    border-width: 2px;\n    height: 30px;\n    padding: 0 8px;\n  }\n  .arrowIcon {\n    width: 10.5px;\n    height: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sectionHeader": `UCqH7PY3GBBxa93VfsWv`,
	"sectionName": `Onx2lHOrDVwVUGNAMXXj`,
	"headerLeft": `AFQshpVRLzmOqw4T8IKy`,
	"headerRight": `gBPUXFzCHwlcBRqlHOTg`,
	"iconWrapper": `GmMESR1jWabG1jr0PVBA`,
	"iconImage": `s8s0GBOw2zfSs7zqRLdZ`,
	"iconSeasonal": `zqctkfpFqyBcMjJaKEEw`,
	"allGamesLink": `y4N_jZuuajlGHIxrBTDY`,
	"arrowIcon": `oJzYTMDTw3iY9ozMXidd`,
	"sectionContainer": `tAQdjpV2tt404lGk0uWj`
};
export default ___CSS_LOADER_EXPORT___;
